export default __webpack_public_path__ + "static/media/SS11-min.c50d1f43.jpg";